import { withInstall } from '@lit-element/utils'

import Tag from './src/tag.vue'
import type { SFCWithInstall } from '@lit-element/utils'

export const LtTag: SFCWithInstall<typeof Tag> = withInstall(Tag)
export default LtTag

export * from './src/tag'
